import { useState, useEffect } from 'react';
import { toDatetimeLocal } from '../../utils/dateUtils';

const EditModal = ({ isOpen, item, title, fields, onSave, onCancel, isLoading }) => {
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (item && fields) {
      const processed = { ...item };
      fields.forEach((field) => {
        if (field.type === 'datetime-local' && processed[field.name]) {
          const d = new Date(processed[field.name]);
          if (!isNaN(d.getTime())) {
            processed[field.name] = toDatetimeLocal(d);
          }
        }
      });
      setFormData(processed);
    }
  }, [item, fields]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const toSave = { ...formData };
    fields.forEach((field) => {
      if (field.type === 'datetime-local' && toSave[field.name]) {
        toSave[field.name] = new Date(toSave[field.name]).toISOString();
      }
    });
    onSave(toSave);
  };

  if (!isOpen) return null;

  return (
    <div
      className="modal d-block"
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: isOpen ? 'block' : 'none',
      }}
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onCancel}
              disabled={isLoading}
            />
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              {fields.map((field) => (
                <div className="mb-3" key={field.name}>
                  <label htmlFor={field.name} className="form-label">
                    {field.label}
                  </label>
                  {field.type === 'textarea' ? (
                    <textarea
                      className="form-control"
                      id={field.name}
                      name={field.name}
                      value={formData[field.name] || ''}
                      onChange={handleChange}
                      rows={field.rows || 3}
                      disabled={isLoading}
                      required={field.required}
                    />
                  ) : field.type === 'select' ? (
                    <select
                      className="form-select"
                      id={field.name}
                      name={field.name}
                      value={formData[field.name] || ''}
                      onChange={handleChange}
                      disabled={isLoading}
                      required={field.required}
                    >
                      <option value="">Select {field.label}</option>
                      {field.options?.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type={field.type}
                      className="form-control"
                      id={field.name}
                      name={field.name}
                      value={formData[field.name] || ''}
                      onChange={handleChange}
                      disabled={isLoading}
                      required={field.required}
                      step={field.step}
                      min={field.min}
                      max={field.max}
                    />
                  )}
                </div>
              ))}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onCancel}
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isLoading}
              >
                {isLoading ? 'Saving...' : 'Save Changes'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditModal;
